export const CV_FILE_SIZE_LIMIT = 52428800;

export const SUPPORT_EMAIL_FILE_SIZE_LIMIT = 26214400;

export const STAGING_STREAMING_KEY = 'T-49d2016b-e492-4851-b9b4-d103244a2fdd';
